function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.29236,4.30374l-7.15,7.15015-.44,1.54992,1.55-.44006,7.15-7.1499Zm3.49-1.8999-.48-.48a.45278.45278,0,0,0-.63,0l-.93.92993,1.12,1.11011.92-.93006A.45287.45287,0,0,0,19.78235,2.40384Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.44,3.61011v-2.21A.62107.62107,0,0,0,13.82.79H1.41a.61467.61467,0,0,0-.62.61011v17.2a.6211.6211,0,0,0,.62.61H13.82a.61459.61459,0,0,0,.62-.61V10.92l.79-.78991v8.47A1.40612,1.40612,0,0,1,13.82,20H1.41A1.41258,1.41258,0,0,1,0,18.6001V1.40015a1.26318,1.26318,0,0,1,.03-.28,1.46267,1.46267,0,0,1,.39-.71A1.3743,1.3743,0,0,1,1.41,0H13.82a1.4127,1.4127,0,0,1,1.41,1.40015V2.82007Z"
});

var SvgIconModifiedConfirmed = function SvgIconModifiedConfirmed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 19.90984 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconModifiedConfirmed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-modified-confirmed.4e657f11.svg";
export { ForwardRef as ReactComponent };